var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Camera",
    d: "M17.4,7.368H15.844l-.879-1.487A1.81,1.81,0,0,0,13.411,5H10.589a1.81,1.81,0,0,0-1.555.881L8.156,7.368H6.6A2.586,2.586,0,0,0,4,9.934v7.5A2.586,2.586,0,0,0,6.6,20H17.4A2.586,2.586,0,0,0,20,17.434v-7.5A2.586,2.586,0,0,0,17.4,7.368ZM15.6,12.3a.6.6,0,0,1-.6.592H13a.592.592,0,1,1,0-1.184h.784a2.366,2.366,0,1,0,.334,2.684.6.6,0,0,1,.811-.247.588.588,0,0,1,.25.8,3.56,3.56,0,1,1-.779-4.3v-.316a.6.6,0,0,1,1.2,0Z",
    transform: "translate(-4 -5)",
    fill: "#0f7bff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/Camera.960768fd.svg";
export { ForwardRef as ReactComponent };